import { useEffect } from "react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { ChatWidget } from "@/components/site/ChatWidget";
import { Contatti } from "@/components/site/Contatti";

export default function ContattiPage() {
  useEffect(() => {
    document.title = "Contatti — SOS Riparazioni 24";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-obsidian" data-testid="contatti-page">
      <Header />
      <main className="pt-20">
        <Contatti />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
